import { atom } from 'recoil';

export const refreshCoveragePackagePricesAtom = atom<object>({
    key: 'refreshCoveragePackagePricesAtom',
    default: {}
});
